import GenericError from "components/GenericError/GenericError"

function ErrorFallback({
    error, 
    resetErrorBoundary
}:{
    error:any, 
    resetErrorBoundary:any
}) {
    
    console.error("ERROR: ", error.message)

    return (
        <GenericError
            error_message={
                error.message
            }
            onCloseModal={resetErrorBoundary}
        />
    )
}

export default ErrorFallback